import { Component, OnInit } from '@angular/core';
import { ProductsService } from '../products/products.service'
import { Category, Product , CategoryResponse, CategoryItems} from '../products/product';
import { ActivatedRoute } from '@angular/router';
import { ControlsService } from '../controls.service';
import { ConfigurationService } from '../configuration.service';

import { Observable } from 'rxjs/Observable';
import { zip } from 'rxjs/observable/zip';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { map, switchMap, publish, tap, take, filter } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs/operators';
import { empty } from 'rxjs/observable/empty';
import { from } from 'rxjs/observable/from';
import { Query } from '../products/query';
import { takeWhile } from 'rxjs/operators';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  ResolveStart,
  ResolveEnd
} from "@angular/router";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {

  categories:Category[] = [];
  products:Product[] = [];
  id: number;
  private sub: any;
  catoriesChildren:CategoryItems[];
  freeOnlyValue: Boolean = false;
  currentcategoryObj: Category = {};
  dataLoading: boolean = false;

  constructor(
    private productsService:ProductsService,
    private route: ActivatedRoute,
    private cs: ControlsService,
    private configurationService:ConfigurationService
  ) { }

  ngOnInit() {

     this.route.params
     .pipe(
      filter((params: any ) => params.id),
      switchMap(p => this.productsService.getCatoriesSingle(+p['id'] ))
     )
     .subscribe(foundCategory => {
        this.currentcategoryObj = foundCategory;
     })

    // this.cs.getFreeControlSubject()
    // .subscribe((value: Boolean) => {
    //   this.freeOnlyValue = value;

    // });

    // combineLatest(
    //   this.cs.getFreeControlSubject().pipe(map(freeMod => (freeMod)? 'free': '')),
    //   this.route.params,
    //   this.route.url,
    //   this.cs.getRecentControlSubject().pipe(map(recentMod => (recentMod)? 'true': '')),
    //   (freeControl: string, params: any, url: any, recentControl: string) => {
    //     let id:number = +params.id ;
    //     let idSet: any = (params.id)? true : false;

    //     return  {filter: {type: freeControl, category: +params.id || null, recent: recentControl || null}, idSet: idSet , path: url[0].path};
    //   }
    // ).pipe(
    //   tap(value => this.dataLoading = true),
    //   // filter((ret: any )=> (ret && ret.filter.hasOwnProperty('category') )),
    //   switchMap((filterObj: any) => (filterObj.path != 'home-page')? this.productsService.getCategorySubItems(filterObj.filter, filterObj.idSet): from([]))
    // )
    // .subscribe((value: CategoryItems[]) => {

    //     // if (value.length){
    //       this.dataLoading = false;
    //     this.catoriesChildren = value;
    //   // }

    //   },
    //   err => {console.log('err', err)},
    //   () => console.log('This is how it ends!')
    // )





}


}



// WEBPACK FOOTER //
// ./src/app/home-page/home-page.component.ts



// WEBPACK FOOTER //
// ./src/app/home-page/home-page.component.ts